
















 
import { useEffect, useState } from "react";
import { getAllTasksApi, getEmployeesApi } from "../../../app/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { updateTaskStatusApi } from "../../../app/api";
import { Pencil } from "lucide-react";
import { createPortal } from "react-dom";
import { Pin,PinOff } from "lucide-react";
import { useRef } from "react";
import TaskDrawer from "../../../components/Tasks/TaskDrawer";
import CreateTaskModal from "../../../components/Tasks/CreateTaskModal";
import TaskSubtasks from "../../../components/Tasks/TaskSubtasks";
import UserProfile from "../../profile/UserProfile";
 
import { deleteTaskApi } from "../../../app/api";
import { Trash2 } from "lucide-react";
import { addSubtaskApi } from "../../../app/api";
 
import { motion, AnimatePresence } from "framer-motion";

import { MoreVertical } from "lucide-react";

import { Eye } from "lucide-react";
const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
 
export default function DailyAttendance() {


  
  const [openMenuId, setOpenMenuId] = useState(null);
  const [recentTaskTimestamps, setRecentTaskTimestamps] = useState(() => {
    const stored = JSON.parse(localStorage.getItem("recentTaskTimestamps") || "{}");
    const now = Date.now();
    const cleaned = {};
    for (const [id, ts] of Object.entries(stored)) {
      if (now - ts < 7 * 24 * 60 * 60 * 1000) {
        cleaned[id] = ts;
      }
    }
    localStorage.setItem("recentTaskTimestamps", JSON.stringify(cleaned));
    return cleaned;
  });
 
  const markTaskAsRecent = (taskId) => {
    const now = Date.now();
    setRecentTaskTimestamps((prev) => {
      const updated = { ...prev, [taskId]: now };
      localStorage.setItem("recentTaskTimestamps", JSON.stringify(updated));
      return updated;
    });
  };
  const [subtaskTitle, setSubtaskTitle] = useState("");
  const [subtaskDate, setSubtaskDate] = useState("");
const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
const [taskToDelete, setTaskToDelete] = useState(null);
const [showUpdateSuccess, setShowUpdateSuccess] = useState(false);
const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
const [showValidationModal, setShowValidationModal] = useState(false);
const [validationMessage, setValidationMessage] = useState("");
 
 
 
 
 
const [selectedSubtaskTask, setSelectedSubtaskTask] = useState(null);
const [expandedTasks, setExpandedTasks] = useState([]);
const [filterOption, setFilterOption] = useState("DEFAULT");


useEffect(() => {
  if (scrollRef.current) {
    scrollRef.current.scrollTo({
      left: 0,
      behavior: "smooth", // optional (use "auto" if you want instant)
    });
  }
}, [filterOption]);
 
const toggleDescription = (taskId) => {
  setExpandedTasks((prev) =>
    prev.includes(taskId)
      ? prev.filter((id) => id !== taskId)
      : [...prev, taskId]
  );
};
 
 
 
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const scrollRef = useRef(null);
  const isDown = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);




// 👇 ADD THIS
const [showAssigneeModal, setShowAssigneeModal] = useState(false);
const [selectedAssignees, setSelectedAssignees] = useState([]);

// 👇 ADD THIS HELPER
const getAssignees = (task) => {
  const names = task.assigned_to_names?.split(",") || [];
  const ids = task.assigned_to_ids?.split(",") || [];
  const pics = task.assigned_to_profile_pics?.split(",") || [];

  return names.map((name, i) => ({
    name: name.trim(),
    id: Number(ids[i]),
    pic: pics[i] || null,
  }));
};







 
 
  const handleMouseDown = (e) => {
    isDown.current = true;
    startX.current = e.pageX - scrollRef.current.offsetLeft;
    scrollLeft.current = scrollRef.current.scrollLeft;
  };
 
  const handleMouseLeave = () => {
    isDown.current = false;
  };
 
  const handleMouseUp = () => {
    isDown.current = false;
  };
 
  const handleMouseMove = (e) => {
    if (!isDown.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.5;
    scrollRef.current.scrollLeft = scrollLeft.current - walk;
  };
 
 
 
 

 
const handleUpdate = async () => {
  try {
    const originalDate = editingTask?.due_date
      ? editingTask.due_date.split(" ")[0]
      : "";
 
    let payload = {
      title: editData.title,
      description: editData.description,
      status: editData.status,
    };
 
    // ✅ ONLY send due_date if changed
    if (editData.due_date !== originalDate) {
      payload.due_date = editData.due_date;
      payload.reason = editData.reason;
 
      // 🔥 Validation
      if (!editData.reason) {
        setValidationMessage("Reason is required when changing due date");
        setShowValidationModal(true);
        return;
      }
    }
 
    await updateTaskStatusApi(editingTask.id, payload);
 
    toast.success("Task updated successfully");
 
    markTaskAsRecent(editingTask.id);
    setEditingTask(null);
    setShowUpdateSuccess(true);
 
    loadTasks();
  } catch (err) {
    toast.error("Failed to update task");
  }
};
 
 
 
  const [editingTask, setEditingTask] = useState(null);
 
 
const [editData, setEditData] = useState({
  title: "",
  description: "",
  status: "",
  due_date: "",
  reason: "",
});
 
 
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([]);
  const [activeTab, setActiveTab] = useState("IN_PROGRESS");
 
  const loadTasks = async () => {
    try {
      const [res, usersRes] = await Promise.all([
        getAllTasksApi(),
        getEmployeesApi()
      ]);

      if (res.success && usersRes.success) {
        // Create a map of active user IDs
        const activeUserIds = new Set(
          usersRes.data.filter(u => u.is_active === 1).map(u => u.id)
        );

        // Filter tasks to only include those that have at least one active assignee
        const filteredTasks = res.data.filter(task => {
          const ids = task.assigned_to_ids?.split(",") || [];
          if (ids.length === 0) return true; // Keep unassigned tasks if any
          
          return ids.some(id => activeUserIds.has(Number(id)));
        });

        setTasks(filteredTasks);
      } else {
        if (res.success) setTasks(res.data);
        else toast.error("Failed to load tasks");
      }
    } catch (e) {
      toast.error("Error loading tasks");
    }
  };
 
  useEffect(() => {
    loadTasks();
  }, []);
 
  // ✅ FILTER LOGIC
 
  const [pinnedTasks, setPinnedTasks] = useState(() => {
    const saved = localStorage.getItem("pinnedTasks");
    return saved ? JSON.parse(saved) : [];
  });
 
  useEffect(() => {
    localStorage.setItem("pinnedTasks", JSON.stringify(pinnedTasks));
  }, [pinnedTasks]);
 
 
 
 
 
  const today = new Date().toISOString().split("T")[0];
 
  const filteredTasks = tasks
  .filter((task) => task.status === "IN_PROGRESS" || task.status === "HOLD")
  .sort((a, b) => {
    const aPinned = pinnedTasks.includes(a.id);
    const bPinned = pinnedTasks.includes(b.id);

    // ✅ 1. PINNED ALWAYS FIRST
    if (aPinned !== bPinned) return bPinned - aPinned;

    const today = new Date().toISOString().split("T")[0];

    // ✅ 2. FILTER BASED SORTING
    if (filterOption === "NEW_TASK") {
      const aCreated = new Date((a.created_at || "").replace(" ", "T")).getTime() || 0;
      const bCreated = new Date((b.created_at || "").replace(" ", "T")).getTime() || 0;
      return bCreated - aCreated;
    }

    if (filterOption === "DEADLINES") {
      const aDue = new Date((a.due_date || "2099-12-31").replace(" ", "T")).getTime();
      const bDue = new Date((b.due_date || "2099-12-31").replace(" ", "T")).getTime();
      return aDue - bDue; // nearest deadline first
    }

    if (filterOption === "NEW_SUBTASK") {
      const aRecent = recentTaskTimestamps[a.id] || 0;
      const bRecent = recentTaskTimestamps[b.id] || 0;
      return bRecent - aRecent;
    }

    // ✅ 3. DEFAULT SMART PRIORITY

    // Today created first
    const aCreatedToday = a.created_at?.split(" ")[0] === today;
    const bCreatedToday = b.created_at?.split(" ")[0] === today;

    if (aCreatedToday !== bCreatedToday) {
      return bCreatedToday - aCreatedToday;
    }

    // Recent activity
    const aRecent = recentTaskTimestamps[a.id] || 0;
    const bRecent = recentTaskTimestamps[b.id] || 0;

    if (aRecent !== bRecent) {
      return bRecent - aRecent;
    }

    // Fallback
    const getTime = (t) => {
      const dateStr = (
        t.calculated_last_activity ||
        t.updated_at ||
        t.created_at ||
        ""
      ).replace(" ", "T");

      return new Date(dateStr).getTime() || 0;
    };

    return getTime(b) - getTime(a);
  });


 
      const borderColors = [
        "border-t-cyan-400",
        "border-t-purple-500",
        "border-t-pink-500",
        "border-t-green-400",
      ];
 
 
 
 
 
 
 
      const [currentPage, setCurrentPage] = useState(1);
      const tasksPerPage = 5; // 👈 change this number (cards per page)
 
 
      const indexOfLastTask = currentPage * tasksPerPage;
      const indexOfFirstTask = indexOfLastTask - tasksPerPage;
      const currentTasks = filteredTasks.slice(indexOfFirstTask, indexOfLastTask);
     
      const totalPages = Math.ceil(filteredTasks.length / tasksPerPage);
 
      useEffect(() => {
        if (currentPage > totalPages) {
          setCurrentPage(1);
        }
      }, [filteredTasks]);
     
 
 
 
     
      const togglePin = (taskId) => {
        setPinnedTasks((prev) =>
          prev.includes(taskId)
            ? prev.filter((id) => id !== taskId) // unpin
            : [...prev, taskId] // pin
        );
      };
 
 
 
 
      const scrollLeftBtn = () => {
        scrollRef.current.scrollBy({
          left: -300,
          behavior: "smooth",
        });
      };
     
      const scrollRightBtn = () => {
        scrollRef.current.scrollBy({
          left: 300,
          behavior: "smooth",
        });
      };
 
 
 
 
 
 
const handleDeleteConfirm = async () => {
  try {
    await deleteTaskApi(taskToDelete.id);
 
    setShowDeleteConfirm(false); // close confirm modal
    setShowDeleteSuccess(true);  // open success modal
 
    loadTasks();
  } catch (err) {
    toast.error("Failed to delete task");
  }
};
 
 
 
const handleConfirmDelete = async () => {
  try {
    await deleteTaskApi(taskToDelete.id);
 
    setShowDeleteConfirm(false);
    setShowDeleteSuccess(true);
    loadTasks();
  } catch (err) {
    toast.error("Failed to delete task");
  }
};
 
 
 

 
 
const handleAddSubtask = async () => {
  if (!subtaskTitle.trim() || !selectedSubtaskTask) return;
 
  try {
    await addSubtaskApi(selectedSubtaskTask.id, {
      title: subtaskTitle,
      start_date: subtaskDate,
    });
 
    setSubtaskTitle("");
    setSubtaskDate("");
 
    // 🔥 MARK THIS TASK AS RECENT
    markTaskAsRecent(selectedSubtaskTask.id);
 
    loadTasks(); // refresh list
 
  } catch (err) {
    console.error("Add subtask error", err);
  }
};
 
 
 
 
 
 
const handleSubtaskUpdate = (taskId) => {
  markTaskAsRecent(taskId);
};
 

return (
  <div
  className="
    relative
    w-full
    bg-gradient-to-br from-[#140c2b] via-[#1f1147] to-[#0f0825]
    border border-white/10
    p-6 rounded-[24px] md:mt-[-4px]
    overflow-hidden no-scrollbar mt-[-64px]
    shadow-2xl
  "
>
  {/* 🌫 Background Floating Light */}
  <div className="absolute top-20 left-20 w-72 h-72 bg-white/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>
  <div className="absolute bottom-10 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>
  <h2 className="text-2xl font-semibold text-white whitespace-nowrap">
Daily Tasks
</h2>


<div className="flex items-center md:justify-end mb-1 md:mt-[-20px] mt-4">





<div className="flex  gap-3 items-end">

<select
value={filterOption}
onChange={(e) => setFilterOption(e.target.value)}
className="
px-3 py-1 text-sm rounded-[10px]
bg-white/10 text-white
border border-white/20
shadow-lg focus:outline-none
backdrop-blur-md outline-none
cursor-pointer
"
>
<option className="text-black" value="DEFAULT">Default</option>
<option className="text-black" value="NEW_TASK">New Task</option>
<option className="text-black" value="NEW_SUBTASK">Newly added subtask</option>
<option className="text-black" value="DEADLINES">Deadlines nearer</option>
</select>

{/* 🔥 NEW Assigned Task Button */}
<button
onClick={() => setShowCreateModal(true)}

className="
px-4 py-1 text-sm rounded-[10px]
bg-gradient-to-r from-cyan-500 to-blue-500
text-white
shadow-lg
hover:scale-105
transition-all duration-300 whitespace-nowrap
"
>
Assign Task
</button>

</div>




</div>




{tasks.length === 0 ? (
<p className="text-gray-300">No tasks available</p>
) : (



<div className="relative">

{/* Left Arrow */}
<button
onClick={scrollLeftBtn}
className="absolute left-[-20px] top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-md text-white p-2 rounded-full"
>
←
</button>

{/* Right Arrow */}
<button
onClick={scrollRightBtn}
className="absolute right-[-20px] top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-md text-white p-2 rounded-full"
>
→
</button>

<div
ref={scrollRef}
className=" relative overflow-x-auto no-scrollbar cursor-grab active:cursor-grabbing select-none"
onMouseDown={handleMouseDown}
onMouseLeave={handleMouseLeave}
onMouseUp={handleMouseUp}
onMouseMove={handleMouseMove}
>


<div className="flex gap-6 w-max px-1 py-4">

{/* {filteredTasks.map((task) => ( */}

{filteredTasks.map((task, index) => {
  const todayDate = new Date().toISOString().split("T")[0];
  const dueDate = task.due_date?.split(" ")[0];

  let deadlineStatus = null;

  if (dueDate && task.status !== "DONE" && task.status !== "HOLD") {
    if (dueDate < todayDate) {
      deadlineStatus = "OVERDUE";
    } else if (dueDate === todayDate) {
      deadlineStatus = "TODAY";
    }
  }







  


return (


  <motion.div key={task.id}
className="relative overflow-hidden rounded-[20px] p-5 backdrop-blur-2xl bg-white/5 border border-white/20 shadow-[0_10px_40px_rgba(0,0,0,0.35)] hover:bg-white/2 transition-all duration-300 flex-shrink-0 w-[220px] "
whileHover={{ scale: 1.03 }}
onClick={() => setSelectedTask(task)}
>
{/* Action Icons */}


<div className="absolute top-2 right-3 flex items-center gap-1 z-10">

  {/* 📌 PIN stays outside */}
  <button
    onClick={(e) => {
      e.stopPropagation();
      togglePin(task.id);
    }}
    className="p-1 bg-white/10 rounded-full hover:bg-white/20 transition"
  >
    {pinnedTasks.includes(task.id) ? (
      <PinOff size={14} className="text-yellow-400" />
    ) : (
      <Pin size={14} className="text-white" />
    )}
  </button>

  {/* ⋮ MENU BUTTON */}
  <div className="relative">
    <button
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenuId(openMenuId === task.id ? null : task.id);
      }}
      className="py-1 rounded-full hover:bg-white/20"
    >
      <MoreVertical size={14} className="text-white" />
    </button>

    {/* DROPDOWN */}
    {openMenuId === task.id && (
      <div className="absolute right-0   bg-[#1e1447]/80 border border-white/20 rounded-lg shadow-lg overflow-hidden z-50">

        {/* EDIT */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setEditingTask(task);
            setEditData({
              title: task.title || "",
              description: task.description || "",
              status: task.status || "",
              due_date: task.due_date
                ? task.due_date.split(" ")[0]
                : "",
              reason: "",
            });
            setOpenMenuId(null);
          }}
          className="w-full text-left px-3 py-2 text-sm hover:bg-white/10"
        >
          <Pencil size={14} className="text-white" />
        </button>

        {/* DELETE */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setTaskToDelete(task);
            setShowDeleteConfirm(true);
            setOpenMenuId(null);
          }}
          className="w-full text-left px-3 py-2 text-sm text-red-400 hover:bg-white/10"
        >
    <Trash2 size={14} className="text-red-400" />
            </button>



      </div>
    )}
  </div>
</div>









{/* Masked Glass Reflection */}
<div className="absolute -top-16 -right-16 w-40 h-40 bg-white/50 rounded-full blur-2xl opacity-50 pointer-events-none"></div>

{/* Creator Info */}
{(() => {
  const assignees = getAssignees(task);
  const count = assignees.length;

  const first = assignees[0];
  const second = assignees[1];

  return (
    // <div className="flex items-center gap-2 mt-[-8px]">
    <div
  className="flex items-center gap-2 mt-[-8px] cursor-pointer"
  onClick={(e) => {
    e.stopPropagation();

    const loggedInUser = JSON.parse(localStorage.getItem("user"));

    // if single user
    if (assignees.length === 1) {
      if (assignees[0].id === loggedInUser.id) {
        navigate("/tasks/my");
      } else {
        navigate(`/users/${assignees[0].id}?tab=task`);
      }
    }
  }}
>

      {/* SINGLE USER */}
      {count === 1 && (
        <>
          {first.pic ? (
            <img
              src={`${IMAGE_BASE_URL}${first.pic}`}
              className="w-8 h-8 rounded-full object-cover border border-white/20"
            />
          ) : (
            <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
              {first.name?.charAt(0).toUpperCase()}
            </div>
          )}

          <p className="text-xs text-gray-300">{first.name}</p>
        </>
      )}

      {/* TWO USERS */}









{count === 2 && (
  <>
    <div className="flex -space-x-2">
      {[first, second].map((user, i) => (
        user.pic ? (
          <img
            key={i}
            src={`${IMAGE_BASE_URL}${user.pic}`}
            onError={(e) => (e.target.src = "/avatar.png")}
            className="w-8 h-8 rounded-full object-cover border border-white"
          />
        ) : (
          <div
            key={i}
            className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs border border-white"
          >
            {user.name?.charAt(0).toUpperCase()}
          </div>
        )
      ))}
    </div>

    {/* 👁 ICON (NEW) */}
    {/* <button
      onClick={(e) => {
        e.stopPropagation();
        setSelectedAssignees(assignees);
        setShowAssigneeModal(true);
      }}
      className="text-white/70 hover:text-white"
    >
      <Eye size={16} />
    </button> */}

<div className="relative group">
  <button
    onClick={(e) => {
      e.stopPropagation();
      setSelectedAssignees(assignees);
      setShowAssigneeModal(true);
    }}
    className="text-white/70 hover:text-white"
  >
    <Eye size={16} />
  </button>

  {/* 👇 TOOLTIP */}
  <div className="
    absolute top-full left-1/2 -translate-x-1/2 mt-2
    hidden group-hover:block
    bg-black text-white text-[10px]
    px-2 py-1 rounded-md
    whitespace-nowrap
    shadow-lg
  ">
    {assignees.map(a => a.name).join(", ")}
  </div>
</div>
  </>
)}

      {/* MORE THAN 2 USERS */}
      {count > 2 && (
        <>
          {/* AVATAR STACK */}
          <div className="flex -space-x-2">
            {[first, second].map((user, i) => (
              user.pic ? (
                <img
                  key={i}
                  src={`${IMAGE_BASE_URL}${user.pic}`}
                  className="w-8 h-8 rounded-full object-cover border border-white"
                />
              ) : (
                <div
                  key={i}
                  className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs border border-white"
                >
                  {user.name?.charAt(0).toUpperCase()}
                </div>
              )
            ))}

            {/* +COUNT */}
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center text-[10px] text-white border border-white">
              +{count - 2}
            </div>
          </div>

          {/* 👁 ICON */}
          {/* <button
            onClick={(e) => {
              e.stopPropagation();
              setSelectedAssignees(assignees);
              setShowAssigneeModal(true);
            }}
            className="text-white/70 hover:text-white"
          >
            <Eye size={16} />
          </button> */}


<div className="relative group">
  <button
    onClick={(e) => {
      e.stopPropagation();
      setSelectedAssignees(assignees);
      setShowAssigneeModal(true);
    }}
    className="text-white/70 hover:text-white"
  >
    <Eye size={16} />
  </button>

  {/* 👇 TOOLTIP */}
  <div className="
    absolute top-full left-1/2 -translate-x-1/2 mt-2
    hidden group-hover:block
    bg-black text-white text-[10px]
    px-2 py-1 rounded-md
    whitespace-nowrap
    shadow-lg
  ">
    {assignees.map(a => a.name).join(", ")}
  </div>
</div>
        </>
      )}
    </div>
  );
})()}



{/* Title & Description */}
<div className="flex justify-between items-start mt-2 gap-2">
<h4 title={task.title} className="text-white font-semibold text-sm line-clamp-2 flex-1">
{task.title}
</h4>

<button
onClick={(e) => {
e.stopPropagation();
setSelectedSubtaskTask(task);
}}
className="bg-purple-500/20 font-bold text-purple-300 text-[10px] px-2 py-1 shadow-lg rounded-full border border-purple-400/30 hover:bg-purple-500/30 transition whitespace-nowrap"
>
Subtasks
</button>
</div>

{/* <p className="text-gray-400 text-sm mt-2 line-clamp-2">{task.description}</p> */}
<p
className={`text-gray-400 text-[12px] mt-2 ${
expandedTasks.includes(task.id) ? "" : "line-clamp-2"
}`}
>
{task.description}
</p>

{task.description?.length > 20 && (
<button
onClick={(e) => {
e.stopPropagation();
toggleDescription(task.id);
}}
className="text-cyan-400 text-[9px] mt-[-18px] hover:underline"
>
{expandedTasks.includes(task.id) ? "Show Less" : "Show More"}
</button>
)}

{/* Dates */}
<div className="flex justify-between text-xs text-gray-400 mt-4">
  <div>
    <p className="text-[10px] mt-[-10px]">Start Date</p>
    <p className="text-gray-300 text-[9px]">{task.created_at?.split(" ")[0] || "14 Aug 2024"}</p>
  </div>
  <div>
    <p className="text-[10px] mt-[-10px]">End Date</p>
    {/* <p className="text-gray-300 text-[9px]">{task.endDate?.split(" ")[0] || "--"}</p> */}
 
    <p className="text-gray-300 text-[9px]">
{task.due_date?.split(" ")[0] || "--"}
</p>
  </div>
</div>











{/* Progress */}
{task.status === "IN_PROGRESS" && (() => {
  let pct = 40;
  if (task.progress) {
    pct = Number(task.progress);
  } else if (task.created_at && task.due_date) {
    const start = new Date(task.created_at.replace(" ", "T"));
    const end = new Date(task.due_date.replace(" ", "T"));
    const now = new Date();
    const total = end - start;
    const passed = now - start;
    if (total > 0) pct = Math.min(Math.max(Math.round((passed / total) * 100), 5), 95);
  }
  return (
    <div className="w-[60%] mt-[-4px]">
      <div className="w-full h-1 bg-white/10 rounded-full overflow-hidden mt-2">
        <div
          className="h-1 bg-gradient-to-r from-cyan-400 to-blue-500 transition-all duration-700"
          style={{ width: `${pct}%` }}
        />
      </div>
      <p className="text-[10px] text-gray-400 mt-1 text-right">{pct}%</p>
    </div>
  );
})()}

{/* </div> */}


{/* Status Badge */}
<div className="flex items-center justify-end mb-[-16px]">




{/* {deadlineStatus && (
  <span
    className={`text-[8px] px-2 py-1 rounded-lg mr-2 shadow-lg border border-red ${
      deadlineStatus === "OVERDUE"
        ? "bg-red-500/20 text-red-400"
        : "bg-yellow-500/20 text-yellow-300"
    }`}
  >
    {deadlineStatus}
  </span>
)} */}


{deadlineStatus && (
  <div className="relative group mr-2">
    
    {/* BADGE */}
    <span
      className={`text-[8px] px-2 py-1 rounded-lg shadow-lg ${
        deadlineStatus === "OVERDUE"
          ? "bg-red-500/20 text-red-400"
          : "bg-yellow-500/20 text-yellow-300"
      }`}
    >
      {deadlineStatus}
    </span>

    {/* TOOLTIP */}
    <div className="
      absolute bottom-full left-1/2 -translate-x-1/2 
      hidden group-hover:block
      px-2 py-1 text-[10px]
      bg-black text-white rounded-md
      whitespace-nowrap shadow-lg
    ">
      {deadlineStatus === "OVERDUE"
        ? "Task is overdue"
        : "Task is due today"}
    </div>

  </div>
)}




  <span
    className={`text-[8px] px-3 py-0.2 rounded-full font-medium backdrop-blur-md bg-white/10 shadow-lg border border-white/20 text-white ${
      task.status === "DONE"
        ? "bg-green-500/20 text-green-400"
        : task.status === "IN_PROGRESS"
        ? "bg-cyan-500/20 text-cyan-400"
        : task.status === "PENDING"
        ? "bg-orange-500/20 text-orange-400"
        : task.status === "HOLD"
        ? "bg-red-500/20 text-red-400"
        : "bg-blue-500/20 text-blue-400"
    }`}
  >
    {task.status?.replace("_", " ")}
  </span>
</div>

</motion.div>

);
  })}
</div>
</div>
</div>
     
    )}



<CreateTaskModal
open={showCreateModal}
onClose={() => setShowCreateModal(false)}
onCreated={loadTasks}
/>
<TaskDrawer
task={selectedTask}
open={!!selectedTask}
onClose={() => setSelectedTask(null)}
onStatusChange={(updated) => {
  setSelectedTask(updated);
  loadTasks();
}}
/>







{editingTask &&
createPortal(
<div className="fixed inset-0 z-[9999] flex items-center justify-center">

{/* Backdrop */}
<div
  onClick={() => setEditingTask(null)}
  className="absolute inset-0 bg-black/60 backdrop-blur-md animate-fadeIn"
/>

{/* Glass Modal */}
<div className="
  relative
  w-[420px]
  max-w-[95%]
  rounded-xl
  bg-white/10
  backdrop-blur-xl
  border border-white/20
  shadow-[0_20px_60px_rgba(0,0,0,0.5)]
  p-6
  text-white
  animate-scaleIn
  shadow-lg
">

  {/* Floating glow */}
  <div className="absolute -top-20 -right-20 w-60 h-60 bg-purple-500/30 rounded-full blur-3xl pointer-events-none" />

  {/* Header */}
  <div className="flex justify-between items-center mb-6">
    <h3 className="text-2xl  font-sans-serif font-semibold tracking-wide">
      Edit Task
    </h3>

    <button
      onClick={() => setEditingTask(null)}
      className="text-white/70 hover:text-white transition"
    >
      ✕
    </button>
  </div>

  {/* Title */}
  <div className="mb-1">
    <label className="text-sm text-white/70">Title</label>
    <input
      type="text"
      value={editData.title}
      onChange={(e) =>
        setEditData({ ...editData, title: e.target.value })
      }
      className="
        w-full mt-1
        bg-white/10
        border border-white/20
        rounded-[8px]
        px-4 py-2
        text-white
        placeholder-white/40
        focus:outline-none
        focus:border-cyan-400
        transition
        shadow-lg
      "
      placeholder="Enter title"
    />
  </div>

  {/* Description */}
  <div className="mb-1">
    <label className="text-sm text-white/70">Description</label>
    <textarea
      value={editData.description}
      onChange={(e) =>
        setEditData({ ...editData, description: e.target.value })
      }
      rows={3}
      className="
        w-full mt-1
        bg-white/10
        border border-white/20
        rounded-[8px]
        px-4 py-2
        text-white
        placeholder-white/40
        focus:outline-none
        focus:border-cyan-400
        transition
        shadow-lg
      "
      placeholder="Enter description"
    />
  </div>


  <div className="mb-3">
<label className="text-sm text-white/70">End Date</label>
<input
type="date"
value={editData.due_date}
onChange={(e) =>
setEditData({ ...editData, due_date: e.target.value })
}
className="w-full mt-1 bg-white/10 border border-white/20 rounded-[8px] px-4 py-2 text-white"
/>
</div>


{/* {editData.due_date !== editingTask?.due_date && ( */}
{editData.due_date !== (editingTask?.due_date?.split(" ")[0] || "") && (
<div className="mb-4">
<label className="text-sm text-white/70">
Reason (required if date changed)
</label>
<textarea
value={editData.reason}
onChange={(e) =>
  setEditData({ ...editData, reason: e.target.value })
}
className="w-full mt-1 bg-white/10 border border-white/20 rounded-[8px] px-4 py-2 text-white"
placeholder="Enter reason"
/>
</div>
)}

  {/* Status */}
  <div className="mb-6">
    <label className="text-sm text-white/70">Status</label>
    <select
      value={editData.status}
      onChange={(e) =>
        setEditData({ ...editData, status: e.target.value })
      }
      className="
        w-full mt-1
        bg-white/10
        border border-white/20
        rounded-[8px]
        px-4 py-2
        text-white
        focus:outline-none
        focus:border-cyan-400
        transition
        shadow-lg
      "
    >
      <option value="PENDING">PENDING</option>
      <option value="IN_PROGRESS">IN_PROGRESS</option>
      <option value="DONE">DONE</option>
    </select>
  </div>

  {/* Buttons */}
  <div className="flex justify-end gap-3">
    <button
      onClick={() => setEditingTask(null)}
      className="
        px-5 py-2
        rounded-[8px]
        bg-white/10
        border border-white/20
        hover:bg-white/20
        transition
        shadow-lg
      "
    >
      Cancel
    </button>

    <button
      onClick={handleUpdate}
      className="
        px-5 py-2
        rounded-[10px]
        bg-gradient-to-r
        from-cyan-500
        to-blue-500
        hover:scale-105
        transition-all
        shadow-lg
      "
    >
      Update
    </button>
  </div>

</div>
</div>,
document.body
)}
{selectedSubtaskTask &&
  createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
 
      {/* Glass Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-md animate-fadeIn"
        onClick={() => setSelectedSubtaskTask(null)}
      />
 
      {/* Glass Modal */}
      <div
        className="
        relative
        w-[520px]
        max-w-[95%]
        rounded-[20px]
        bg-white/10
        backdrop-blur-2xl
        border border-white/20
        shadow-[0_20px_60px_rgba(0,0,0,0.6)]
        p-6
        text-white
        animate-scaleIn
        overflow-hidden
       
      "
      >
 
        {/* Floating Glow */}
        <div className="absolute -top-20 -right-20 w-60 h-60 bg-purple-500/30 rounded-full blur-3xl pointer-events-none"></div>
<div className="absolute -bottom-20 -left-20 w-60 h-60 bg-cyan-400/30 rounded-full blur-3xl pointer-events-none"></div>
 
        {/* Header */}
        <div className="flex justify-between items-center mb-3">
  <h3 className="text-xl font-semibold tracking-wide">
    Subtasks - {selectedSubtaskTask.title}
  </h3>
 
  <button
    onClick={() => setSelectedSubtaskTask(null)}
    className="text-white/70 hover:text-white transition text-lg"
  >
    ✕
  </button>
</div>
     
 
        {/* Subtask List */}
        <div className="max-h-[320px] overflow-y-auto pr-1 space-y-3 no-scrollbar">
        {/* <TaskSubtasks taskId={selectedSubtaskTask.id} /> */}
 
     
 
<TaskSubtasks
  taskId={selectedSubtaskTask.id}
  onSubtaskUpdate={() => handleSubtaskUpdate(selectedSubtaskTask.id)}
/>
        </div>
 
      </div>
    </div>,
    document.body
  )}
 
 
 
 
 
{showValidationModal && createPortal(
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
    <div className="w-[90%] max-w-md bg-[#1e1447] rounded-2xl p-6 text-white shadow-2xl">
     
      <h3 className="text-lg font-semibold mb-3 text-center">
        ⚠️ Validation Error
      </h3>
 
      <p className="text-center text-white/70 mb-5">
        {validationMessage}
      </p>
 
      <button
        onClick={() => setShowValidationModal(false)}
        className="w-full py-2 rounded-lg bg-gradient-to-r from-red-500 to-pink-500"
      >
        Okay
      </button>
    </div>
  </div>,
    document.body
)}
 
 
 
 
 
 
 
 
 
{showUpdateSuccess && createPortal(
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
    <div className="w-[90%] max-w-md bg-gradient-to-br from-[#2d1c6a] to-[#12082f] rounded-2xl p-6 text-white shadow-2xl">
     
      <div className="text-center text-3xl mb-3">✅</div>
 
      <h3 className="text-lg font-semibold text-center mb-2">
        Task Updated
      </h3>
 
      <p className="text-center text-white/70 mb-5">
        Task updated successfully.
      </p>
 
      <button
        onClick={() => setShowUpdateSuccess(false)}
        className="w-full py-2 rounded-lg bg-gradient-to-r from-cyan-500 to-blue-500"
      >
        Okay
      </button>
    </div>
  </div>,
 
document.body
)}
 
 
 
 
 
 
 
 
 
{showDeleteSuccess && createPortal(
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
    <div className="w-[90%] max-w-md bg-gradient-to-br from-[#2d1c6a] to-[#12082f] rounded-2xl p-6 text-white shadow-2xl">
     
      <div className="text-center text-3xl mb-3">🗑</div>
 
      <h3 className="text-lg font-semibold text-center mb-2">
        Task Deleted
      </h3>
 
      <p className="text-center text-white/70 mb-5">
        Task deleted successfully.
      </p>
 
      <button
        onClick={() => setShowDeleteSuccess(false)}
        className="w-full py-2 rounded-lg bg-gradient-to-r from-red-500 to-pink-500"
      >
        Okay
      </button>
    </div>
  </div>,
  document.body
 
)}
 
 
 
 
 
 
{showDeleteConfirm && createPortal(
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
   
    <div className="w-[90%] max-w-md bg-gradient-to-br from-[#2d1c6a] to-[#12082f] rounded-2xl p-6 text-white shadow-2xl">
     
      {/* ICON */}
      <div className="text-center text-3xl mb-3">⚠️</div>
 
      {/* TITLE */}
      <h3 className="text-lg font-semibold text-center mb-2">
        Delete Task?
      </h3>
 
      {/* MESSAGE */}
      <p className="text-center text-white/70 mb-6">
        Are you sure you want to delete this task? This action cannot be undone.
      </p>
 
      {/* ACTION BUTTONS */}
      <div className="flex gap-3">
       
        {/* CANCEL */}
        <button
          onClick={() => setShowDeleteConfirm(false)}
          className="w-full py-2 rounded-lg bg-white/10 border border-white/20"
        >
          Cancel
        </button>
 
        {/* DELETE */}
        <button
          onClick={handleDeleteConfirm}
          className="w-full py-2 rounded-lg bg-gradient-to-r from-red-500 to-pink-500"
        >
          Delete
        </button>
 
      </div>
    </div>
  </div>,
    document.body
 
)}











{showAssigneeModal &&
  createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">

      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-md"
        onClick={() => setShowAssigneeModal(false)}
      />

      {/* MODAL */}
      <div className="relative w-[350px] max-w-[90%] bg-[#1e1447]/90 backdrop-blur-xl border border-white/20 rounded-xl p-5 text-white">

        <h3 className="text-lg font-semibold mb-4 text-center">
          Assignees
        </h3>

        <div className="space-y-3 max-h-[300px] overflow-y-auto">

       


{selectedAssignees.map((user, i) => (
  <div
    key={i}
    className="p-2 rounded-lg hover:bg-white/10 cursor-pointer text-sm"
    onClick={() => {
      // navigate(`/users/${user.id}?tab=task`);
      setShowAssigneeModal(false);
    }}
  >
    {user.name}
  </div>
))}

        </div>

        <button
          onClick={() => setShowAssigneeModal(false)}
          className="mt-4 w-full py-2 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-lg"
        >
          Close
        </button>
      </div>
    </div>,
    document.body
  )}
 
        </div>
       
      );
     
 
}
 
 
 
 
 








 
// import { useEffect, useState } from "react";
// import { getAllTasksApi } from "../../../app/api";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { updateTaskStatusApi } from "../../../app/api";
// import { Pencil } from "lucide-react";
// import { createPortal } from "react-dom";
// import { Pin,PinOff } from "lucide-react";
// import { useRef } from "react";
// import TaskDrawer from "../../../components/Tasks/TaskDrawer";
// import CreateTaskModal from "../../../components/Tasks/CreateTaskModal";
// import TaskSubtasks from "../../../components/Tasks/TaskSubtasks";
// import UserProfile from "../../profile/UserProfile";
 
// import { deleteTaskApi } from "../../../app/api";
// import { Trash2 } from "lucide-react";
// import { addSubtaskApi } from "../../../app/api";
 
// import { motion, AnimatePresence } from "framer-motion";

// import { MoreVertical } from "lucide-react";

// import { Eye } from "lucide-react";
// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
 
// export default function DailyAttendance() {


  
//   const [openMenuId, setOpenMenuId] = useState(null);
//   const [recentTaskTimestamps, setRecentTaskTimestamps] = useState(() => {
//     const stored = JSON.parse(localStorage.getItem("recentTaskTimestamps") || "{}");
//     const now = Date.now();
//     const cleaned = {};
//     for (const [id, ts] of Object.entries(stored)) {
//       if (now - ts < 7 * 24 * 60 * 60 * 1000) {
//         cleaned[id] = ts;
//       }
//     }
//     localStorage.setItem("recentTaskTimestamps", JSON.stringify(cleaned));
//     return cleaned;
//   });
 
//   const markTaskAsRecent = (taskId) => {
//     const now = Date.now();
//     setRecentTaskTimestamps((prev) => {
//       const updated = { ...prev, [taskId]: now };
//       localStorage.setItem("recentTaskTimestamps", JSON.stringify(updated));
//       return updated;
//     });
//   };
//   const [subtaskTitle, setSubtaskTitle] = useState("");
//   const [subtaskDate, setSubtaskDate] = useState("");
// const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
// const [taskToDelete, setTaskToDelete] = useState(null);
// const [showUpdateSuccess, setShowUpdateSuccess] = useState(false);
// const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
// const [showValidationModal, setShowValidationModal] = useState(false);
// const [validationMessage, setValidationMessage] = useState("");
 
 
 
 
 
// const [selectedSubtaskTask, setSelectedSubtaskTask] = useState(null);
// const [expandedTasks, setExpandedTasks] = useState([]);
// const [filterOption, setFilterOption] = useState("DEFAULT");
 
// const toggleDescription = (taskId) => {
//   setExpandedTasks((prev) =>
//     prev.includes(taskId)
//       ? prev.filter((id) => id !== taskId)
//       : [...prev, taskId]
//   );
// };
 
 
 
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [selectedTask, setSelectedTask] = useState(null);
//   const scrollRef = useRef(null);
//   const isDown = useRef(false);
//   const startX = useRef(0);
//   const scrollLeft = useRef(0);




// // 👇 ADD THIS
// const [showAssigneeModal, setShowAssigneeModal] = useState(false);
// const [selectedAssignees, setSelectedAssignees] = useState([]);

// // 👇 ADD THIS HELPER
// const getAssignees = (task) => {
//   const names = task.assigned_to_names?.split(",") || [];
//   const ids = task.assigned_to_ids?.split(",") || [];
//   const pics = task.assigned_to_profile_pics?.split(",") || [];

//   return names.map((name, i) => ({
//     name: name.trim(),
//     id: Number(ids[i]),
//     pic: pics[i] || null,
//   }));
// };







 
 
//   const handleMouseDown = (e) => {
//     isDown.current = true;
//     startX.current = e.pageX - scrollRef.current.offsetLeft;
//     scrollLeft.current = scrollRef.current.scrollLeft;
//   };
 
//   const handleMouseLeave = () => {
//     isDown.current = false;
//   };
 
//   const handleMouseUp = () => {
//     isDown.current = false;
//   };
 
//   const handleMouseMove = (e) => {
//     if (!isDown.current) return;
//     e.preventDefault();
//     const x = e.pageX - scrollRef.current.offsetLeft;
//     const walk = (x - startX.current) * 1.5;
//     scrollRef.current.scrollLeft = scrollLeft.current - walk;
//   };
 
 
 
 

 
// const handleUpdate = async () => {
//   try {
//     const originalDate = editingTask?.due_date
//       ? editingTask.due_date.split(" ")[0]
//       : "";
 
//     let payload = {
//       title: editData.title,
//       description: editData.description,
//       status: editData.status,
//     };
 
//     // ✅ ONLY send due_date if changed
//     if (editData.due_date !== originalDate) {
//       payload.due_date = editData.due_date;
//       payload.reason = editData.reason;
 
//       // 🔥 Validation
//       if (!editData.reason) {
//         setValidationMessage("Reason is required when changing due date");
//         setShowValidationModal(true);
//         return;
//       }
//     }
 
//     await updateTaskStatusApi(editingTask.id, payload);
 
//     toast.success("Task updated successfully");
 
//     markTaskAsRecent(editingTask.id);
//     setEditingTask(null);
//     setShowUpdateSuccess(true);
 
//     loadTasks();
//   } catch (err) {
//     toast.error("Failed to update task");
//   }
// };
 
 
 
//   const [editingTask, setEditingTask] = useState(null);
 
 
// const [editData, setEditData] = useState({
//   title: "",
//   description: "",
//   status: "",
//   due_date: "",
//   reason: "",
// });
 
 
//   const navigate = useNavigate();
//   const [tasks, setTasks] = useState([]);
//   const [activeTab, setActiveTab] = useState("IN_PROGRESS");
 
//   const loadTasks = async () => {
//     const res = await getAllTasksApi();
 
//     if (res.success) {
//       setTasks(res.data);
//     } else {
//       toast.error("Failed to load tasks");
//     }
//   };
 
//   useEffect(() => {
//     loadTasks();
//   }, []);
 
//   // ✅ FILTER LOGIC
 
//   const [pinnedTasks, setPinnedTasks] = useState(() => {
//     const saved = localStorage.getItem("pinnedTasks");
//     return saved ? JSON.parse(saved) : [];
//   });
 
//   useEffect(() => {
//     localStorage.setItem("pinnedTasks", JSON.stringify(pinnedTasks));
//   }, [pinnedTasks]);
 
 
 
 
 
//   const today = new Date().toISOString().split("T")[0];
 
//   const filteredTasks = tasks
//   .filter((task) => task.status === "IN_PROGRESS")
//   .sort((a, b) => {
//     const aPinned = pinnedTasks.includes(a.id);
//     const bPinned = pinnedTasks.includes(b.id);

//     // ✅ 1. PINNED ALWAYS FIRST
//     if (aPinned !== bPinned) return bPinned - aPinned;

//     const today = new Date().toISOString().split("T")[0];

//     // ✅ 2. FILTER BASED SORTING
//     if (filterOption === "NEW_TASK") {
//       const aCreated = new Date((a.created_at || "").replace(" ", "T")).getTime() || 0;
//       const bCreated = new Date((b.created_at || "").replace(" ", "T")).getTime() || 0;
//       return bCreated - aCreated;
//     }

//     if (filterOption === "DEADLINES") {
//       const aDue = new Date((a.due_date || "2099-12-31").replace(" ", "T")).getTime();
//       const bDue = new Date((b.due_date || "2099-12-31").replace(" ", "T")).getTime();
//       return aDue - bDue; // nearest deadline first
//     }

//     if (filterOption === "NEW_SUBTASK") {
//       const aRecent = recentTaskTimestamps[a.id] || 0;
//       const bRecent = recentTaskTimestamps[b.id] || 0;
//       return bRecent - aRecent;
//     }

//     // ✅ 3. DEFAULT SMART PRIORITY

//     // Today created first
//     const aCreatedToday = a.created_at?.split(" ")[0] === today;
//     const bCreatedToday = b.created_at?.split(" ")[0] === today;

//     if (aCreatedToday !== bCreatedToday) {
//       return bCreatedToday - aCreatedToday;
//     }

//     // Recent activity
//     const aRecent = recentTaskTimestamps[a.id] || 0;
//     const bRecent = recentTaskTimestamps[b.id] || 0;

//     if (aRecent !== bRecent) {
//       return bRecent - aRecent;
//     }

//     // Fallback
//     const getTime = (t) => {
//       const dateStr = (
//         t.calculated_last_activity ||
//         t.updated_at ||
//         t.created_at ||
//         ""
//       ).replace(" ", "T");

//       return new Date(dateStr).getTime() || 0;
//     };

//     return getTime(b) - getTime(a);
//   });


 
//       const borderColors = [
//         "border-t-cyan-400",
//         "border-t-purple-500",
//         "border-t-pink-500",
//         "border-t-green-400",
//       ];
 
 
 
 
 
 
 
//       const [currentPage, setCurrentPage] = useState(1);
//       const tasksPerPage = 5; // 👈 change this number (cards per page)
 
 
//       const indexOfLastTask = currentPage * tasksPerPage;
//       const indexOfFirstTask = indexOfLastTask - tasksPerPage;
//       const currentTasks = filteredTasks.slice(indexOfFirstTask, indexOfLastTask);
     
//       const totalPages = Math.ceil(filteredTasks.length / tasksPerPage);
 
//       useEffect(() => {
//         if (currentPage > totalPages) {
//           setCurrentPage(1);
//         }
//       }, [filteredTasks]);
     
 
 
 
     
//       const togglePin = (taskId) => {
//         setPinnedTasks((prev) =>
//           prev.includes(taskId)
//             ? prev.filter((id) => id !== taskId) // unpin
//             : [...prev, taskId] // pin
//         );
//       };
 
 
 
 
//       const scrollLeftBtn = () => {
//         scrollRef.current.scrollBy({
//           left: -300,
//           behavior: "smooth",
//         });
//       };
     
//       const scrollRightBtn = () => {
//         scrollRef.current.scrollBy({
//           left: 300,
//           behavior: "smooth",
//         });
//       };
 
 
 
 
 
 
// const handleDeleteConfirm = async () => {
//   try {
//     await deleteTaskApi(taskToDelete.id);
 
//     setShowDeleteConfirm(false); // close confirm modal
//     setShowDeleteSuccess(true);  // open success modal
 
//     loadTasks();
//   } catch (err) {
//     toast.error("Failed to delete task");
//   }
// };
 
 
 
// const handleConfirmDelete = async () => {
//   try {
//     await deleteTaskApi(taskToDelete.id);
 
//     setShowDeleteConfirm(false);
//     setShowDeleteSuccess(true);
//     loadTasks();
//   } catch (err) {
//     toast.error("Failed to delete task");
//   }
// };
 
 
 

 
 
// const handleAddSubtask = async () => {
//   if (!subtaskTitle.trim() || !selectedSubtaskTask) return;
 
//   try {
//     await addSubtaskApi(selectedSubtaskTask.id, {
//       title: subtaskTitle,
//       start_date: subtaskDate,
//     });
 
//     setSubtaskTitle("");
//     setSubtaskDate("");
 
//     // 🔥 MARK THIS TASK AS RECENT
//     markTaskAsRecent(selectedSubtaskTask.id);
 
//     loadTasks(); // refresh list
 
//   } catch (err) {
//     console.error("Add subtask error", err);
//   }
// };
 
 
 
 
 
 
// const handleSubtaskUpdate = (taskId) => {
//   markTaskAsRecent(taskId);
// };
 

// return (
//   <div
//   className="
//     relative
//     w-full
//     bg-gradient-to-br
//     from-[#1e1447]
//     via-[#24155a]
//     to-[#12082f]
//     p-6 rounded-[24px] md:mt-[-4px]
//     overflow-hidden mt-[-64px]
//   "
// >
//   {/* 🌫 Background Floating Light */}
//   <div className="absolute top-20 left-20 w-72 h-72 bg-white/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>
//   <div className="absolute bottom-10 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>
//   <h2 className="text-2xl font-semibold text-white whitespace-nowrap">
// Daily Tasks
// </h2>


// <div className="flex items-center md:justify-end mb-1 md:mt-[-20px] mt-4">





// <div className="flex  gap-3 items-end">

// <select
// value={filterOption}
// onChange={(e) => setFilterOption(e.target.value)}
// className="
// px-3 py-1 text-sm rounded-[10px]
// bg-white/10 text-white
// border border-white/20
// shadow-lg focus:outline-none
// backdrop-blur-md outline-none
// cursor-pointer
// "
// >
// <option className="text-black" value="DEFAULT">Default</option>
// <option className="text-black" value="NEW_TASK">New Task</option>
// <option className="text-black" value="NEW_SUBTASK">Newly added subtask</option>
// <option className="text-black" value="DEADLINES">Deadlines nearer</option>
// </select>

// {/* 🔥 NEW Assigned Task Button */}
// <button
// onClick={() => setShowCreateModal(true)}

// className="
// px-4 py-1 text-sm rounded-[10px]
// bg-gradient-to-r from-cyan-500 to-blue-500
// text-white
// shadow-lg
// hover:scale-105
// transition-all duration-300 whitespace-nowrap
// "
// >
// Assign Task
// </button>

// </div>




// </div>




// {tasks.length === 0 ? (
// <p className="text-gray-300">No tasks available</p>
// ) : (



// <div className="relative">

// {/* Left Arrow */}
// <button
// onClick={scrollLeftBtn}
// className="absolute left-[-20px] top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-md text-white p-2 rounded-full"
// >
// ←
// </button>

// {/* Right Arrow */}
// <button
// onClick={scrollRightBtn}
// className="absolute right-[-20px] top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-md text-white p-2 rounded-full"
// >
// →
// </button>

// <div
// ref={scrollRef}
// className=" relative overflow-x-auto no-scrollbar cursor-grab active:cursor-grabbing select-none"
// onMouseDown={handleMouseDown}
// onMouseLeave={handleMouseLeave}
// onMouseUp={handleMouseUp}
// onMouseMove={handleMouseMove}
// >


// <div className="flex gap-6 w-max px-1 py-4">

// {/* {filteredTasks.map((task) => ( */}

// {filteredTasks.map((task, index) => {
//   const todayDate = new Date().toISOString().split("T")[0];
//   const dueDate = task.due_date?.split(" ")[0];

//   let deadlineStatus = null;

//   if (dueDate && task.status !== "DONE") {
//     if (dueDate < todayDate) {
//       deadlineStatus = "OVERDUE";
//     } else if (dueDate === todayDate) {
//       deadlineStatus = "TODAY";
//     }
//   }






// return (


//   <motion.div key={task.id}
// className="relative overflow-hidden rounded-[20px] p-5 backdrop-blur-2xl bg-white/5 border border-white/20 shadow-[0_10px_40px_rgba(0,0,0,0.35)] hover:bg-white/2 transition-all duration-300 flex-shrink-0 w-[220px]"
// whileHover={{ scale: 1.03 }}
// onClick={() => setSelectedTask(task)}
// >
// {/* Action Icons */}


// <div className="absolute top-2 right-3 flex items-center gap-1 z-10">

//   {/* 📌 PIN stays outside */}
//   <button
//     onClick={(e) => {
//       e.stopPropagation();
//       togglePin(task.id);
//     }}
//     className="p-1 bg-white/10 rounded-full hover:bg-white/20 transition"
//   >
//     {pinnedTasks.includes(task.id) ? (
//       <PinOff size={14} className="text-yellow-400" />
//     ) : (
//       <Pin size={14} className="text-white" />
//     )}
//   </button>

//   {/* ⋮ MENU BUTTON */}
//   <div className="relative">
//     <button
//       onClick={(e) => {
//         e.stopPropagation();
//         setOpenMenuId(openMenuId === task.id ? null : task.id);
//       }}
//       className="py-1 rounded-full hover:bg-white/20"
//     >
//       <MoreVertical size={14} className="text-white" />
//     </button>

//     {/* DROPDOWN */}
//     {openMenuId === task.id && (
//       <div className="absolute right-0   bg-[#1e1447]/80 border border-white/20 rounded-lg shadow-lg overflow-hidden z-50">

//         {/* EDIT */}
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             setEditingTask(task);
//             setEditData({
//               title: task.title || "",
//               description: task.description || "",
//               status: task.status || "",
//               due_date: task.due_date
//                 ? task.due_date.split(" ")[0]
//                 : "",
//               reason: "",
//             });
//             setOpenMenuId(null);
//           }}
//           className="w-full text-left px-3 py-2 text-sm hover:bg-white/10"
//         >
//           <Pencil size={14} className="text-white" />
//         </button>

//         {/* DELETE */}
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             setTaskToDelete(task);
//             setShowDeleteConfirm(true);
//             setOpenMenuId(null);
//           }}
//           className="w-full text-left px-3 py-2 text-sm text-red-400 hover:bg-white/10"
//         >
//     <Trash2 size={14} className="text-red-400" />
//             </button>



//       </div>
//     )}
//   </div>
// </div>









// {/* Masked Glass Reflection */}
// <div className="absolute -top-16 -right-16 w-40 h-40 bg-white/50 rounded-full blur-2xl opacity-50 pointer-events-none"></div>

// {/* Creator Info */}
// {(() => {
//   const assignees = getAssignees(task);
//   const count = assignees.length;

//   const first = assignees[0];
//   const second = assignees[1];

//   return (
//     // <div className="flex items-center gap-2 mt-[-8px]">
//     <div
//   className="flex items-center gap-2 mt-[-8px] cursor-pointer"
//   onClick={(e) => {
//     e.stopPropagation();

//     const loggedInUser = JSON.parse(localStorage.getItem("user"));

//     // if single user
//     if (assignees.length === 1) {
//       if (assignees[0].id === loggedInUser.id) {
//         navigate("/tasks/my");
//       } else {
//         navigate(`/users/${assignees[0].id}?tab=task`);
//       }
//     }
//   }}
// >

//       {/* SINGLE USER */}
//       {count === 1 && (
//         <>
//           {first.pic ? (
//             <img
//               src={`${IMAGE_BASE_URL}${first.pic}`}
//               className="w-8 h-8 rounded-full object-cover border border-white/20"
//             />
//           ) : (
//             <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
//               {first.name?.charAt(0).toUpperCase()}
//             </div>
//           )}

//           <p className="text-xs text-gray-300">{first.name}</p>
//         </>
//       )}

//       {/* TWO USERS */}









// {count === 2 && (
//   <>
//     <div className="flex -space-x-2">
//       {[first, second].map((user, i) => (
//         user.pic ? (
//           <img
//             key={i}
//             src={`${IMAGE_BASE_URL}${user.pic}`}
//             onError={(e) => (e.target.src = "/avatar.png")}
//             className="w-8 h-8 rounded-full object-cover border border-white"
//           />
//         ) : (
//           <div
//             key={i}
//             className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs border border-white"
//           >
//             {user.name?.charAt(0).toUpperCase()}
//           </div>
//         )
//       ))}
//     </div>

//     {/* 👁 ICON (NEW) */}
//     {/* <button
//       onClick={(e) => {
//         e.stopPropagation();
//         setSelectedAssignees(assignees);
//         setShowAssigneeModal(true);
//       }}
//       className="text-white/70 hover:text-white"
//     >
//       <Eye size={16} />
//     </button> */}

// <div className="relative group">
//   <button
//     onClick={(e) => {
//       e.stopPropagation();
//       setSelectedAssignees(assignees);
//       setShowAssigneeModal(true);
//     }}
//     className="text-white/70 hover:text-white"
//   >
//     <Eye size={16} />
//   </button>

//   {/* 👇 TOOLTIP */}
//   <div className="
//     absolute top-full left-1/2 -translate-x-1/2 mt-2
//     hidden group-hover:block
//     bg-black text-white text-[10px]
//     px-2 py-1 rounded-md
//     whitespace-nowrap
//     shadow-lg
//   ">
//     {assignees.map(a => a.name).join(", ")}
//   </div>
// </div>
//   </>
// )}

//       {/* MORE THAN 2 USERS */}
//       {count > 2 && (
//         <>
//           {/* AVATAR STACK */}
//           <div className="flex -space-x-2">
//             {[first, second].map((user, i) => (
//               user.pic ? (
//                 <img
//                   key={i}
//                   src={`${IMAGE_BASE_URL}${user.pic}`}
//                   className="w-8 h-8 rounded-full object-cover border border-white"
//                 />
//               ) : (
//                 <div
//                   key={i}
//                   className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs border border-white"
//                 >
//                   {user.name?.charAt(0).toUpperCase()}
//                 </div>
//               )
//             ))}

//             {/* +COUNT */}
//             <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center text-[10px] text-white border border-white">
//               +{count - 2}
//             </div>
//           </div>

//           {/* 👁 ICON */}
//           {/* <button
//             onClick={(e) => {
//               e.stopPropagation();
//               setSelectedAssignees(assignees);
//               setShowAssigneeModal(true);
//             }}
//             className="text-white/70 hover:text-white"
//           >
//             <Eye size={16} />
//           </button> */}


// <div className="relative group">
//   <button
//     onClick={(e) => {
//       e.stopPropagation();
//       setSelectedAssignees(assignees);
//       setShowAssigneeModal(true);
//     }}
//     className="text-white/70 hover:text-white"
//   >
//     <Eye size={16} />
//   </button>

//   {/* 👇 TOOLTIP */}
//   <div className="
//     absolute top-full left-1/2 -translate-x-1/2 mt-2
//     hidden group-hover:block
//     bg-black text-white text-[10px]
//     px-2 py-1 rounded-md
//     whitespace-nowrap
//     shadow-lg
//   ">
//     {assignees.map(a => a.name).join(", ")}
//   </div>
// </div>
//         </>
//       )}
//     </div>
//   );
// })()}



// {/* Title & Description */}
// <div className="flex justify-between items-start mt-2 gap-2">
// <h4 title={task.title} className="text-white font-semibold text-sm line-clamp-2 flex-1">
// {task.title}
// </h4>

// <button
// onClick={(e) => {
// e.stopPropagation();
// setSelectedSubtaskTask(task);
// }}
// className="bg-purple-500/20 font-bold text-purple-300 text-[10px] px-2 py-1 shadow-lg rounded-full border border-purple-400/30 hover:bg-purple-500/30 transition whitespace-nowrap"
// >
// Subtasks
// </button>
// </div>

// {/* <p className="text-gray-400 text-sm mt-2 line-clamp-2">{task.description}</p> */}
// <p
// className={`text-gray-400 text-[12px] mt-2 ${
// expandedTasks.includes(task.id) ? "" : "line-clamp-2"
// }`}
// >
// {task.description}
// </p>

// {task.description?.length > 20 && (
// <button
// onClick={(e) => {
// e.stopPropagation();
// toggleDescription(task.id);
// }}
// className="text-cyan-400 text-[9px] mt-[-18px] hover:underline"
// >
// {expandedTasks.includes(task.id) ? "Show Less" : "Show More"}
// </button>
// )}

// {/* Dates */}
// <div className="flex justify-between text-xs text-gray-400 mt-4">
//   <div>
//     <p className="text-[10px] mt-[-10px]">Start Date</p>
//     <p className="text-gray-300 text-[9px]">{task.created_at?.split(" ")[0] || "14 Aug 2024"}</p>
//   </div>
//   <div>
//     <p className="text-[10px] mt-[-10px]">End Date</p>
//     {/* <p className="text-gray-300 text-[9px]">{task.endDate?.split(" ")[0] || "--"}</p> */}
 
//     <p className="text-gray-300 text-[9px]">
// {task.due_date?.split(" ")[0] || "--"}
// </p>
//   </div>
// </div>











// {/* Progress (Right) */}
// {task.status === "IN_PROGRESS" && (
// <div className="w-[60%] mt-[-4px]">
// <div className="w-full h-1 bg-white/10 rounded-full overflow-hidden mt-2">
//   <div
//     className="h-1 bg-gradient-to-r from-cyan-400 to-blue-500 "
//     style={{ width: task.progress ? `${task.progress}%` : "40%" }}
//   />
// </div>
// <div className="flex justify-between items-center mb-[-14px] mt-3">

// {/* Subtask Button (Left) */}

// <p className="text-[10px] text-gray-400 mt-[-4px] text-right">
//   {task.progress ? `${task.progress}%` : "40%"}
// </p>
// </div>
// </div>
// )}

// {/* </div> */}


// {/* Status Badge */}
// <div className="flex items-center justify-end mb-[-16px]">




// {/* {deadlineStatus && (
//   <span
//     className={`text-[8px] px-2 py-1 rounded-lg mr-2 shadow-lg border border-red ${
//       deadlineStatus === "OVERDUE"
//         ? "bg-red-500/20 text-red-400"
//         : "bg-yellow-500/20 text-yellow-300"
//     }`}
//   >
//     {deadlineStatus}
//   </span>
// )} */}


// {deadlineStatus && (
//   <div className="relative group mr-2">
    
//     {/* BADGE */}
//     <span
//       className={`text-[8px] px-2 py-1 rounded-lg shadow-lg ${
//         deadlineStatus === "OVERDUE"
//           ? "bg-red-500/20 text-red-400"
//           : "bg-yellow-500/20 text-yellow-300"
//       }`}
//     >
//       {deadlineStatus}
//     </span>

//     {/* TOOLTIP */}
//     <div className="
//       absolute bottom-full left-1/2 -translate-x-1/2 
//       hidden group-hover:block
//       px-2 py-1 text-[10px]
//       bg-black text-white rounded-md
//       whitespace-nowrap shadow-lg
//     ">
//       {deadlineStatus === "OVERDUE"
//         ? "Task is overdue"
//         : "Task is due today"}
//     </div>

//   </div>
// )}




//   <span
//     className={`text-[8px] px-3 py-0.2 rounded-full font-medium backdrop-blur-md bg-white/10 shadow-lg border border-white/20 text-white ${
//       task.status === "DONE"
//         ? "bg-green-500/20 text-green-400"
//         : task.status === "IN_PROGRESS"
//         ? "bg-cyan-500/20 text-cyan-400"
//         : task.status === "PENDING"
//         ? "bg-orange-500/20 text-orange-400"
//         : "bg-blue-500/20 text-blue-400"
//     }`}
//   >
//     {task.status}
//   </span>
// </div>

// </motion.div>

// );
//   })}
// </div>
// </div>
// </div>
     
//     )}



// <CreateTaskModal
// open={showCreateModal}
// onClose={() => setShowCreateModal(false)}
// onCreated={loadTasks}
// />
// <TaskDrawer
// task={selectedTask}
// open={!!selectedTask}
// onClose={() => setSelectedTask(null)}
// onUpdated={loadTasks}
// />







// {editingTask &&
// createPortal(
// <div className="fixed inset-0 z-[9999] flex items-center justify-center">

// {/* Backdrop */}
// <div
//   onClick={() => setEditingTask(null)}
//   className="absolute inset-0 bg-black/60 backdrop-blur-md animate-fadeIn"
// />

// {/* Glass Modal */}
// <div className="
//   relative
//   w-[420px]
//   max-w-[95%]
//   rounded-xl
//   bg-white/10
//   backdrop-blur-xl
//   border border-white/20
//   shadow-[0_20px_60px_rgba(0,0,0,0.5)]
//   p-6
//   text-white
//   animate-scaleIn
//   shadow-lg
// ">

//   {/* Floating glow */}
//   <div className="absolute -top-20 -right-20 w-60 h-60 bg-purple-500/30 rounded-full blur-3xl pointer-events-none" />

//   {/* Header */}
//   <div className="flex justify-between items-center mb-6">
//     <h3 className="text-2xl  font-sans-serif font-semibold tracking-wide">
//       Edit Task
//     </h3>

//     <button
//       onClick={() => setEditingTask(null)}
//       className="text-white/70 hover:text-white transition"
//     >
//       ✕
//     </button>
//   </div>

//   {/* Title */}
//   <div className="mb-1">
//     <label className="text-sm text-white/70">Title</label>
//     <input
//       type="text"
//       value={editData.title}
//       onChange={(e) =>
//         setEditData({ ...editData, title: e.target.value })
//       }
//       className="
//         w-full mt-1
//         bg-white/10
//         border border-white/20
//         rounded-[8px]
//         px-4 py-2
//         text-white
//         placeholder-white/40
//         focus:outline-none
//         focus:border-cyan-400
//         transition
//         shadow-lg
//       "
//       placeholder="Enter title"
//     />
//   </div>

//   {/* Description */}
//   <div className="mb-1">
//     <label className="text-sm text-white/70">Description</label>
//     <textarea
//       value={editData.description}
//       onChange={(e) =>
//         setEditData({ ...editData, description: e.target.value })
//       }
//       rows={3}
//       className="
//         w-full mt-1
//         bg-white/10
//         border border-white/20
//         rounded-[8px]
//         px-4 py-2
//         text-white
//         placeholder-white/40
//         focus:outline-none
//         focus:border-cyan-400
//         transition
//         shadow-lg
//       "
//       placeholder="Enter description"
//     />
//   </div>


//   <div className="mb-3">
// <label className="text-sm text-white/70">End Date</label>
// <input
// type="date"
// value={editData.due_date}
// onChange={(e) =>
// setEditData({ ...editData, due_date: e.target.value })
// }
// className="w-full mt-1 bg-white/10 border border-white/20 rounded-[8px] px-4 py-2 text-white"
// />
// </div>


// {/* {editData.due_date !== editingTask?.due_date && ( */}
// {editData.due_date !== (editingTask?.due_date?.split(" ")[0] || "") && (
// <div className="mb-4">
// <label className="text-sm text-white/70">
// Reason (required if date changed)
// </label>
// <textarea
// value={editData.reason}
// onChange={(e) =>
//   setEditData({ ...editData, reason: e.target.value })
// }
// className="w-full mt-1 bg-white/10 border border-white/20 rounded-[8px] px-4 py-2 text-white"
// placeholder="Enter reason"
// />
// </div>
// )}

//   {/* Status */}
//   <div className="mb-6">
//     <label className="text-sm text-white/70">Status</label>
//     <select
//       value={editData.status}
//       onChange={(e) =>
//         setEditData({ ...editData, status: e.target.value })
//       }
//       className="
//         w-full mt-1
//         bg-white/10
//         border border-white/20
//         rounded-[8px]
//         px-4 py-2
//         text-white
//         focus:outline-none
//         focus:border-cyan-400
//         transition
//         shadow-lg
//       "
//     >
//       <option value="PENDING">PENDING</option>
//       <option value="IN_PROGRESS">IN_PROGRESS</option>
//       <option value="DONE">DONE</option>
//     </select>
//   </div>

//   {/* Buttons */}
//   <div className="flex justify-end gap-3">
//     <button
//       onClick={() => setEditingTask(null)}
//       className="
//         px-5 py-2
//         rounded-[8px]
//         bg-white/10
//         border border-white/20
//         hover:bg-white/20
//         transition
//         shadow-lg
//       "
//     >
//       Cancel
//     </button>

//     <button
//       onClick={handleUpdate}
//       className="
//         px-5 py-2
//         rounded-[10px]
//         bg-gradient-to-r
//         from-cyan-500
//         to-blue-500
//         hover:scale-105
//         transition-all
//         shadow-lg
//       "
//     >
//       Update
//     </button>
//   </div>

// </div>
// </div>,
// document.body
// )}
// {selectedSubtaskTask &&
//   createPortal(
//     <div className="fixed inset-0 z-[9999] flex items-center justify-center">
 
//       {/* Glass Backdrop */}
//       <div
//         className="absolute inset-0 bg-black/60 backdrop-blur-md animate-fadeIn"
//         onClick={() => setSelectedSubtaskTask(null)}
//       />
 
//       {/* Glass Modal */}
//       <div
//         className="
//         relative
//         w-[520px]
//         max-w-[95%]
//         rounded-[20px]
//         bg-white/10
//         backdrop-blur-2xl
//         border border-white/20
//         shadow-[0_20px_60px_rgba(0,0,0,0.6)]
//         p-6
//         text-white
//         animate-scaleIn
//         overflow-hidden
       
//       "
//       >
 
//         {/* Floating Glow */}
//         <div className="absolute -top-20 -right-20 w-60 h-60 bg-purple-500/30 rounded-full blur-3xl pointer-events-none"></div>
// <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-cyan-400/30 rounded-full blur-3xl pointer-events-none"></div>
 
//         {/* Header */}
//         <div className="flex justify-between items-center mb-3">
//   <h3 className="text-xl font-semibold tracking-wide">
//     Subtasks - {selectedSubtaskTask.title}
//   </h3>
 
//   <button
//     onClick={() => setSelectedSubtaskTask(null)}
//     className="text-white/70 hover:text-white transition text-lg"
//   >
//     ✕
//   </button>
// </div>
     
 
//         {/* Subtask List */}
//         <div className="max-h-[320px] overflow-y-auto pr-1 space-y-3 no-scrollbar">
//         {/* <TaskSubtasks taskId={selectedSubtaskTask.id} /> */}
 
     
 
// <TaskSubtasks
//   taskId={selectedSubtaskTask.id}
//   onSubtaskUpdate={() => handleSubtaskUpdate(selectedSubtaskTask.id)}
// />
//         </div>
 
//       </div>
//     </div>,
//     document.body
//   )}
 
 
 
 
 
// {showValidationModal && createPortal(
//   <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
//     <div className="w-[90%] max-w-md bg-[#1e1447] rounded-2xl p-6 text-white shadow-2xl">
     
//       <h3 className="text-lg font-semibold mb-3 text-center">
//         ⚠️ Validation Error
//       </h3>
 
//       <p className="text-center text-white/70 mb-5">
//         {validationMessage}
//       </p>
 
//       <button
//         onClick={() => setShowValidationModal(false)}
//         className="w-full py-2 rounded-lg bg-gradient-to-r from-red-500 to-pink-500"
//       >
//         Okay
//       </button>
//     </div>
//   </div>,
//     document.body
// )}
 
 
 
 
 
 
 
 
 
// {showUpdateSuccess && createPortal(
//   <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
//     <div className="w-[90%] max-w-md bg-gradient-to-br from-[#2d1c6a] to-[#12082f] rounded-2xl p-6 text-white shadow-2xl">
     
//       <div className="text-center text-3xl mb-3">✅</div>
 
//       <h3 className="text-lg font-semibold text-center mb-2">
//         Task Updated
//       </h3>
 
//       <p className="text-center text-white/70 mb-5">
//         Task updated successfully.
//       </p>
 
//       <button
//         onClick={() => setShowUpdateSuccess(false)}
//         className="w-full py-2 rounded-lg bg-gradient-to-r from-cyan-500 to-blue-500"
//       >
//         Okay
//       </button>
//     </div>
//   </div>,
 
// document.body
// )}
 
 
 
 
 
 
 
 
 
// {showDeleteSuccess && createPortal(
//   <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
//     <div className="w-[90%] max-w-md bg-gradient-to-br from-[#2d1c6a] to-[#12082f] rounded-2xl p-6 text-white shadow-2xl">
     
//       <div className="text-center text-3xl mb-3">🗑</div>
 
//       <h3 className="text-lg font-semibold text-center mb-2">
//         Task Deleted
//       </h3>
 
//       <p className="text-center text-white/70 mb-5">
//         Task deleted successfully.
//       </p>
 
//       <button
//         onClick={() => setShowDeleteSuccess(false)}
//         className="w-full py-2 rounded-lg bg-gradient-to-r from-red-500 to-pink-500"
//       >
//         Okay
//       </button>
//     </div>
//   </div>,
//   document.body
 
// )}
 
 
 
 
 
 
// {showDeleteConfirm && createPortal(
//   <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
   
//     <div className="w-[90%] max-w-md bg-gradient-to-br from-[#2d1c6a] to-[#12082f] rounded-2xl p-6 text-white shadow-2xl">
     
//       {/* ICON */}
//       <div className="text-center text-3xl mb-3">⚠️</div>
 
//       {/* TITLE */}
//       <h3 className="text-lg font-semibold text-center mb-2">
//         Delete Task?
//       </h3>
 
//       {/* MESSAGE */}
//       <p className="text-center text-white/70 mb-6">
//         Are you sure you want to delete this task? This action cannot be undone.
//       </p>
 
//       {/* ACTION BUTTONS */}
//       <div className="flex gap-3">
       
//         {/* CANCEL */}
//         <button
//           onClick={() => setShowDeleteConfirm(false)}
//           className="w-full py-2 rounded-lg bg-white/10 border border-white/20"
//         >
//           Cancel
//         </button>
 
//         {/* DELETE */}
//         <button
//           onClick={handleDeleteConfirm}
//           className="w-full py-2 rounded-lg bg-gradient-to-r from-red-500 to-pink-500"
//         >
//           Delete
//         </button>
 
//       </div>
//     </div>
//   </div>,
//     document.body
 
// )}











// {showAssigneeModal &&
//   createPortal(
//     <div className="fixed inset-0 z-[9999] flex items-center justify-center">

//       {/* BACKDROP */}
//       <div
//         className="absolute inset-0 bg-black/60 backdrop-blur-md"
//         onClick={() => setShowAssigneeModal(false)}
//       />

//       {/* MODAL */}
//       <div className="relative w-[350px] max-w-[90%] bg-[#1e1447]/90 backdrop-blur-xl border border-white/20 rounded-xl p-5 text-white">

//         <h3 className="text-lg font-semibold mb-4 text-center">
//           Assignees
//         </h3>

//         <div className="space-y-3 max-h-[300px] overflow-y-auto">

       


// {selectedAssignees.map((user, i) => (
//   <div
//     key={i}
//     className="p-2 rounded-lg hover:bg-white/10 cursor-pointer text-sm"
//     onClick={() => {
//       // navigate(`/users/${user.id}?tab=task`);
//       setShowAssigneeModal(false);
//     }}
//   >
//     {user.name}
//   </div>
// ))}

//         </div>

//         <button
//           onClick={() => setShowAssigneeModal(false)}
//           className="mt-4 w-full py-2 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-lg"
//         >
//           Close
//         </button>
//       </div>
//     </div>,
//     document.body
//   )}
 
//         </div>
       
//       );
     
 
// }
 
 
 
 
 




